/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IaaCProjectRoleDTO = {
    Owner: 'owner',
    Member: 'member'
} as const;
export type IaaCProjectRoleDTO = typeof IaaCProjectRoleDTO[keyof typeof IaaCProjectRoleDTO];


export function instanceOfIaaCProjectRoleDTO(value: any): boolean {
    for (const key in IaaCProjectRoleDTO) {
        if (Object.prototype.hasOwnProperty.call(IaaCProjectRoleDTO, key)) {
            if (IaaCProjectRoleDTO[key as keyof typeof IaaCProjectRoleDTO] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IaaCProjectRoleDTOFromJSON(json: any): IaaCProjectRoleDTO {
    return IaaCProjectRoleDTOFromJSONTyped(json, false);
}

export function IaaCProjectRoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): IaaCProjectRoleDTO {
    return json as IaaCProjectRoleDTO;
}

export function IaaCProjectRoleDTOToJSON(value?: IaaCProjectRoleDTO | null): any {
    return value as any;
}

